import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import '../index.css';
import { NavBar } from '../components/NavBar';
import { FooterDefault } from '../components/Footer';

export default class MainLayout extends Component {
  static propTypes = {
    children: PropTypes.any,
    logoVisible: PropTypes.bool,
    useHashLinks: PropTypes.bool,
  };

  static defaultProps = {
    logoVisible: false,
    useHashlinks: false,
  };

  state = {
    isFixed: false,
  };

  constructor(props) {
    super(props);
    this.handleStickyStateChange = this.handleStickyStateChange.bind(this);
  }

  handleStickyStateChange({status}) {
    this.setState({
      isFixed: status === Sticky.STATUS_FIXED,
    });
  }

  render() {
    const { children, logoVisible, useHashLinks } = this.props;
    const { isFixed} = this.state;
    return <div className="min-h-screen flex flex-col">
      <Sticky innerZ={50} onStateChange={this.handleStickyStateChange}>
        <NavBar isFixed={isFixed} logoVisible={logoVisible} useHashLinks={useHashLinks}/>
      </Sticky>
      {children}
      <FooterDefault className="mt-auto"/>
    </div>;

  }
};



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.js